import { render, staticRenderFns } from "./DesktopIcons.vue?vue&type=template&id=6bd6fa88&scoped=true"
import script from "./DesktopIcons.vue?vue&type=script&lang=js"
export * from "./DesktopIcons.vue?vue&type=script&lang=js"
import style0 from "./DesktopIcons.vue?vue&type=style&index=0&id=6bd6fa88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6fa88",
  null
  
)

export default component.exports